export enum TreasuryLinkAccountTypeEnum {
  'fire' = 'Fire',
  'ais' = 'Ais'
}
